'use client';

import Link from 'next/link';

type SuccessToastProps = {
  title: string;
};

const SuccessToast = ({ title }: SuccessToastProps) => (
  <div className="p-toast-message-text">
    <span className="p-toast-summary">Success</span>
    <div className="p-toast-detail">{`${title} added to cart!`}</div>
    <Link prefetch={false} href="/solutions/cart" style={{ color: 'white' }}>
      Go to cart
    </Link>
  </div>
);

export default SuccessToast;
